import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_END_POINTS } from '@app/config/api.constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvestmentUniverseService {

  private $viewUniverse: BehaviorSubject<any> = new BehaviorSubject(null)
  private $submitTemplate: BehaviorSubject<any> = new BehaviorSubject(null)
  constructor(
    private http: HttpClient
  ) { }

  public set setViewUniverse(universe: any){
    this.$viewUniverse.next(universe)
  }

  public get viewUniverseId (): Observable<any> {
    return this.$viewUniverse.asObservable()
  }

  public set submitTemplate(submitTmep: any){
    this.$submitTemplate.next(submitTmep)
  }

  public get getSubmitTemplate (): Observable<any> {
    return this.$submitTemplate.asObservable()
  }

  getInvestmentUniverse(greenConfigId?: string): Observable<any>{
    if(greenConfigId){
      return this.http.get(`${API_END_POINTS.SETUP.GREEN.investment_universe}?greenConfigId=${greenConfigId}`);
    } else{
      return this.http.get(API_END_POINTS.SETUP.GREEN.investment_universe);
    }
  }

  createInvestmentUniverse(data: any) : Observable<any> {
    return this.http.post(API_END_POINTS.SETUP.GREEN.add_investment_universe, data)
  }

  updateInvestmentUniverse(data: any, greenConfigId: string) : Observable<any> {
    return this.http.post(`${API_END_POINTS.SETUP.GREEN.edit_investment_universe}?greenConfigId=${greenConfigId}`, data)
  }

  getInvestments(greenConfigId: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.SETUP.GREEN.green_universe}?greenConfigId=${greenConfigId}`)
  }

  uploadExcel(greenConfigId: string, file: any): Observable<any>{
    const formData = new FormData()
    formData.append('file', file)
    return this.http.post(`${API_END_POINTS.SETUP.GREEN.upload_excel}?greenConfigId=${greenConfigId}`, formData)
  }

  downloadExcel(greenConfigId: string){
    return this.http.get(`${API_END_POINTS.SETUP.GREEN.download_excel}?greenConfigId=${greenConfigId}`, {responseType: 'arraybuffer'})
  }

  getGreenGroupInfo(greenConfigId: string): Observable<any>{
    return this.http.get(`${API_END_POINTS.SETUP.GREEN.groupinfo}?greenConfigId=${greenConfigId}`)
  }

  deleteGreenInstrument(greenConfigId: string,pickrightAssetId: string): Observable<any>{
    return this.http.delete(`${API_END_POINTS.SETUP.GREEN.green_universe}?greenConfigId=${greenConfigId}&pickrightAssetId=${pickrightAssetId}`)
  }

  getInstrumentPeers(assetChildren: string, sector: string): Observable<any>{
    if(sector){
      return this.http.get(`${API_END_POINTS.SETUP.PUBLISH_MASTER.instrument_publish_master}?assetChildren=${assetChildren}&sector=${sector}`)
    } else {
      return this.http.get(`${API_END_POINTS.SETUP.PUBLISH_MASTER.instrument_publish_master}?assetChildren=${assetChildren}`)
    }
  }

  addInstrumentPeer(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.SETUP.GREEN.peers, data)
  }

  deleteInstrumentPeer(greenUniverseConfigId: string, id: string) : Observable<any> {
    return this.http.delete(`${API_END_POINTS.SETUP.GREEN.peers}?greenUniverseConfigId=${greenUniverseConfigId}&id=${id}`)
  }

  updateGreenInstrument(greenConfigId: string, pickrightAssetId: string, data: any): Observable<any> {
    return this.http.put(`${API_END_POINTS.SETUP.GREEN.green_universe}?greenConfigId=${greenConfigId}&pickrightAssetId=${pickrightAssetId}`, data)
  }

  updateInstrumentPriority(data: any): Observable<any> {
    return this.http.put(API_END_POINTS.SETUP.GREEN.priority, data)
  }

  getPublishedMaster(): Observable<any> {
    return this.http.get(API_END_POINTS.SETUP.PUBLISH_MASTER.publish_master)
  }
}
